import React, { useEffect, useState, useRef } from "react";
import { motion } from "framer-motion";
import { Link, useParams } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import MainHeader from "../Components/MainHeader";
import NotFound from "./NotFound";
import { blogs } from "../Blog";
import breadcrumbSchema from "../Schema/BreadcrumbSchema";
import blogPostingSchema from "../Schema/BlogPostingSchema";
import SchemaMarkup from "../Components/SchemaMarkup";


const BlogDetail=()=>{
     const { url } = useParams();
     const [scrollProgress, setScrollProgress] = useState(0);

  const blog = blogs.find(
    (item) => item.url === url
  );

  useEffect(() => {
    if (!blog) return;
    document.title = blog.metaTitle;

    const metaDesc = document.querySelector("meta[name='description']");
    if (metaDesc) metaDesc.setAttribute("content", blog.metaDescription);

      let canonical = document.querySelector("link[rel='canonical']");
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    document.head.appendChild(canonical);
  }

  canonical.setAttribute(
    "href",
    `https://irisimpulse.com/blogs/${url}`
  );

   const ogTitle = document.querySelector("meta[property='og:title']");
  if (ogTitle) {
    ogTitle.setAttribute(
      "content",
    blog.metaTitle
    );
  }

    const ogDesc = document.querySelector("meta[property='og:description']");
  if (ogDesc) {
    ogDesc.setAttribute(
      "content",
     blog.metaDescription
    );
  }

  const ogUrl = document.querySelector("meta[property='og:url']");
  if (ogUrl) {
    ogUrl.setAttribute("content",  `https://irisimpulse.com/blogs/${url}`);
  }

    const ogImage = document.querySelector("meta[property='og:image']");
  if (ogImage) {
    ogImage.setAttribute(
      "content",
      (`https://irisimpulse.com${blog.image}`)
    );
  }

    const twitterTitle = document.querySelector("meta[name='twitter:title']");
  if (twitterTitle) {
    twitterTitle.setAttribute(
      "content",
    blog.metaTitle
    );
  }

    const twitterDesc = document.querySelector(
    "meta[name='twitter:description']"
  );
  if (twitterDesc) {
    twitterDesc.setAttribute(
      "content",
    blog.metaDescription
    );
  }

    const twitterImage = document.querySelector("meta[name='twitter:image']");
  if (twitterImage) {
    twitterImage.setAttribute(
      "content",
      (`https://irisimpulse.com${blog.image}`)
    );
  }

}, [blog, url]);

useEffect(() => {

  const updateProgress = () => {

    const progressBar = document.querySelector(
      ".blog-progress-bar"
    );

    const titleSection = document.querySelector(
      ".blog-detail-top"
    );

    if (!progressBar || !titleSection) return;

    const titleRect =
      titleSection.getBoundingClientRect();

    /* =========================
       SHOW BAR ONLY AFTER
       TITLE FULLY HIDES
    ========================= */

    const triggerPoint = 120;

    if (titleRect.bottom <= triggerPoint) {

      progressBar.classList.add("active");

      /* =========================
         START COUNTING FROM
         EXACT MOMENT BAR APPEARS
      ========================= */

      const startScroll =
        window.scrollY +
        titleRect.bottom -
        triggerPoint;

      const totalScrollable =
        document.documentElement.scrollHeight -
        window.innerHeight -
        startScroll;

      const currentScrollable =
        window.scrollY - startScroll;

      const progress =
        (currentScrollable / totalScrollable) * 100;

      setScrollProgress(
        Math.max(0, Math.min(progress, 100))
      );

    } else {

      progressBar.classList.remove("active");

      setScrollProgress(0);
    }
  };

  window.addEventListener("scroll", updateProgress);

  updateProgress();

  return () => {
    window.removeEventListener(
      "scroll",
      updateProgress
    );
  };

}, []);

  const prevRef = useRef(null);
  const nextRef = useRef(null);
  
  if (!blog) return <NotFound />;

const breadcrumbData = breadcrumbSchema({
  items: [
    {
      name: "Home",
      url: "https://irisimpulse.com/",
    },
    {
      name: "Blogs",
      url: "https://irisimpulse.com/blogs",
    },
    {
      name: blog.title,
    },
  ],
});

const blogPostingData = blogPostingSchema({
  url: `https://irisimpulse.com/blogs/${blog.url}`,
  title: blog.title,
  description: blog.metaDescription || blog.description,
  image: blog.image,
  datePublished: blog.datePublished,
  author: blog.author,
});

    return(
        <>
         <SchemaMarkup data={breadcrumbData} />
        <SchemaMarkup data={blogPostingData} />

        <MainHeader />


      <section className="blog-detail">

        {/* =========================
   STICKY PROGRESS BAR
========================= */}

<div className="blog-progress-bar">

  <div className="blog-progress-content container">

    <p className="blog-progress-title">
      {blog.title}
    </p>

    <Link
      to="/blogs"
      className="underline-btn"
    >
      All Blogs
    </Link>

  </div>

  {/* PROGRESS LINE */}

  <span
    className="blog-progress-line"
    style={{
      width: `${scrollProgress}%`
    }}
  />

</div>

        {/* =========================
           TOP CONTENT
        ========================= */}

        <div className="blog-detail-top container">

          <h1 className="blog-heading">
            {blog.title}
          </h1>

          <div className="blog-detail-meta">

            <span>
              {blog.category?.[0]}
            </span>

            <span className="meta-divider"></span>

            <span>
              {blog.date}
            </span>

            <span className="meta-divider"></span>

            <span>
              By {blog.author}
            </span>

          </div>

        </div>

        {/* =========================
           FULL WIDTH IMAGE
        ========================= */}

        <div className="blog-detail-banner">

          <img
            src={blog.image}
            alt={`${blog.title} | Iris Impulse India Pvt. Ltd.`}
            className="blog-detail-image"
          />

        </div>

        {/* =========================
           BLOG CONTENT
        ========================= */}

        <div className="blog-detail-content container">

          <div
            dangerouslySetInnerHTML={{
              __html: blog.content
            }}
          />

        </div>

      </section>

      <section className="slider-section slider-home container related-blog-section">

  {/* HEADING */}

  <h2 className="section-heading">
    Other Related Blogs
  </h2>

  <div className="slider-container-wrapper">

    {/* ARROWS */}

    <div
      ref={prevRef}
      className="custom-arrow prev-arrow"
    >
      <span>&#10094;</span>
    </div>

    <div
      ref={nextRef}
      className="custom-arrow next-arrow"
    >
      <span>&#10095;</span>
    </div>

    <Swiper
      modules={[Navigation, Pagination]}
      slidesPerView={3}
      spaceBetween={50}
      loop={true}
      navigation={{
        prevEl: prevRef.current,
        nextEl: nextRef.current,
      }}
      pagination={{
        clickable: true,
      }}
      onBeforeInit={(swiper) => {
        swiper.params.navigation.prevEl =
          prevRef.current;

        swiper.params.navigation.nextEl =
          nextRef.current;
      }}
      breakpoints={{
        320: {
          slidesPerView: 1,
          spaceBetween: 15,
        },

        576: {
          slidesPerView: 1,
          spaceBetween: 20,
        },

        768: {
          slidesPerView: 2,
          spaceBetween: 30,
        },

        1024: {
          slidesPerView: 2,
          spaceBetween: 40,
        },

        1400: {
          slidesPerView: 3,
          spaceBetween: 50,
        },
      }}
      className="slider-cards-grid"
    >

  {blogs
  .filter((item) => item.id !== blog.id)
  .map((item) => (

    <SwiperSlide key={item.id}>
                 
      <motion.div
        className="slide-card"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7, ease: "easeOut" }}
        whileHover={{ y: -8 }}
      >

        <div className="image-wrapper">
          <motion.img
            src={item.image}
            alt={`${item.title} | Iris Impulse India Pvt. Ltd.`}
            initial={{ scale: 1.05 }}
            whileInView={{ scale: 1 }}
            transition={{ duration: 1.2, ease: "easeOut" }}
          />
        </div>

        <div className="slide-content">

          <h3>{item.title}</h3>

          <p className="description">
            {item.description}
          </p>

          <motion.a
            href={`/blogs/${item.url}`}
            className="underline-btn"
            whileHover={{ x: 5 }}
            whileTap={{ scale: 0.97 }}
          >
            READ MORE
          </motion.a>

        </div>

      </motion.div>

    </SwiperSlide>
))}

    </Swiper>

  </div>

</section>
        </>
    )
}

export default BlogDetail;